import { colors } from "@src/theme"
import styled from "styled-components"

export const MenuBackDrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 9;
`

export const SubscribeLink = styled.a<{ disabled: boolean }>`
  line-height: 2rem;
  font-size: 1rem;
  color: ${colors.white};
  &:hover {
    color: ${colors.white};
    cursor: ${({ disabled }) => disabled && "auto"};
    text-decoration: ${({ disabled }) => disabled && "none"};
  }
`
